import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormTextField from '../form/FormTextField';
import { Grid } from '@material-ui/core';

const RespondentVerificationForm = ({ email, readonly }) => (
  <div className="row">
    <div className="box-header-outside">
      <div className="col-sm-12">
        <div className="header">
          <h2>Weryfikacja głosu</h2>
        </div>
      </div>
    </div>
    <div className="box">
      <p>Po wysłaniu głosu, na wskazany adres e-mail zostanie wysłany link do weryfikacji. Twój głos będzie ważny tylko po weryfikacji adresu e-mail.</p>
      <div className="col-sm-12">
        <Grid container spacing={2} alignItems="flex-end">
          {email ? <Grid item xs={12} md={6}>
            <Field
              name="emailToVerify"
              component={FormTextField}
              type="email"
              label="Adres e-mail"
              placeholder="Wprowadź adres e-mail"
              fullWidth
              disabled={readonly}
              inputProps={{ 'aria-label': "Adres e-mail" }}
            />
          </Grid> : null}
        </Grid>
      </div>
    </div>
  </div>
);

RespondentVerificationForm.propTypes = {
  email: PropTypes.bool.isRequired,
  readonly: PropTypes.bool
};

export default RespondentVerificationForm;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/RespondentVerificationForm.js